import Hero from '../../components/MiscellaneusComponents/Hero/Hero';
import './Home.css'

const Home = () => {
  return (
    <div className='home'>
      <Hero />
    </div>
  )
};

export default Home;